import axios from "axios";
import { isThisHour } from "date-fns";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  GetResellerList({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: "/reseller/list?order_by=created_on&order_dir=desc",
        params: {
          page: list.page || 0,
          reseller_name: list.reseller_name ? "*" + list.reseller_name + "*" : '',
          per_page: list.per_page ? list.per_page : '',
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  GetReseller({ commit }, reseller_uuid) {
    return new Promise(resolve => {
      axios({
        url: "/reseller/" + reseller_uuid,
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  DeleteReseller({ commit }, reseller_uuid) {
    return new Promise(resolve => {
      axios({
        url: "/reseller/" + reseller_uuid,
        method: "DELETE"
      }).then(res => {
        console.log(res);
        resolve(res.data.payload);
      });
    });
  },
  EditReseller({ commit }, reseller) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/reseller/" + reseller.reseller_uuid,
        data: reseller.reseller,
        method: "PATCH"
      })
        .then(res => {
          resolve(res.data.payload);
        })
        .catch(err => {
          console.log("err.response.data", err.response.data)
          reject(err.response.data);
        });
    });
  },
  AddReseller({ commit }, reseller) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/reseller",
        data: reseller,
        method: "POST"
      })
        .then(res => {
          resolve(res.data.payload);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  UploadResellerFile({ commit }, form) {
    return axios.post("/reseller/import", form).then(res => {
      return res.data
    }).catch(res => {
      console.log(res);
    })
  }
};

// mutations
const mutations = {};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
